import { Label } from "@tandemdiabetes/sugarmate-react-components"
import { Follower } from "./Follower"
import styles from "./Sharing.module.scss"
import { usePolyglot } from "src/contexts"
import { useSharingFollows } from "src/hooks"

const polyglotPrefix = "pages.data_sharing.share_my_data.active_followers."

export function FollowersList() {
  const polyglot = usePolyglot()
  const followers = useSharingFollows()

  return (
    <div className={styles.list}>
      <Label className={styles.sectionLabel}>
        {polyglot.t(`${polyglotPrefix}label`)}
      </Label>
      {followers.map((follow) => (
        <Follower
          key={follow.id}
          follow={follow}
        />
      ))}
    </div>
  )
}
